import axios from 'axios';
import { Auth } from '@aws-amplify/auth';

async function httpInterceptor (config) {
  try {
    let session = await Auth.currentSession();
    const token = session.getIdToken().getJwtToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  catch (e) {
    // no current user
  }
  return config;
}

axios.interceptors.request.use(httpInterceptor);
